export function useFormatNumber () {
  const currencyFormat = (val) => {
    return val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',')
  }
  return { currencyFormat }
}
